export default __webpack_public_path__ + "static/media/express-scripts-glyph.fe2d5898.png";